import { render, staticRenderFns } from "./NbTablev2.vue?vue&type=template&id=ae194362&"
import script from "./NbTablev2.vue?vue&type=script&lang=js&"
export * from "./NbTablev2.vue?vue&type=script&lang=js&"
import style0 from "./NbTablev2.vue?vue&type=style&index=0&id=ae194362&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports